import { Warning } from '@mui/icons-material';
import { Alert } from '@mui/material'
import { t } from 'i18next';
import { isNumber } from 'lodash';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useLazyGetWarehousesManualStatusQuery } from 'src/_api/warehouseApi';

export default function WarehousesManualAlert() {

    // Merchant (DMS) [No coords - No city]
    //  MapitShip (No coords - No city - and city name must be like oto)

    const [getWarehousesManualStatus] = useLazyGetWarehousesManualStatusQuery()

    const [manualWarehouseExist, setManualWarehouseExist] = useState(false)
    const [openAlert, setOpenAlert] = useState(true);

    const getWarehousesManualStatusHandler = async () => {
        try {
            const result = await getWarehousesManualStatus().unwrap()
            setManualWarehouseExist(result)
        } catch (error) {
            console.error("Error fetching warehouses manual status:", error)
        }
    }

    useEffect(() => {
        getWarehousesManualStatusHandler()
    }, [])


    return (
        <>
            {
                (openAlert && isNumber(manualWarehouseExist) && !!manualWarehouseExist) ?
                    <Alert
                        variant="filled"
                        icon={<Warning />}
                        onClose={() => setOpenAlert(false)}
                        sx={{ mb: 1, bgcolor: "#ffbc0d", color: "black", mx: 1 }}
                    >
                        {t("warehousesAlert")}&nbsp;
                        <Link style={{ color: "white", textDecoration: "underline" }} to="/merchant/warehouse">{t("Update Warehouses")}</Link>

                    </Alert> :
                    <></>
            }
        </>
    )
}
